import { LikeTargetType } from 'types/like-target.types';

export class LikeTarget {
  public static readonly PRODUCT: LikeTargetType = 'product';
  public static readonly USER: LikeTargetType = 'user';

  public static isProduct(type: LikeTargetType): boolean {
    return type === LikeTarget.PRODUCT;
  }

  public static isUser(type: LikeTargetType): boolean {
    return type === LikeTarget.USER;
  }
}
